var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiOrganizeControl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93408 10.7064C8.88451 10.735 8.8284 10.7523 8.77036 10.7551L6.90025 10.8454C6.36947 10.8708 5.91288 10.819 5.50388 10.6877C4.60898 10.4008 3.858 9.80277 3.3898 9.003L1.8478 6.37126C1.66977 6.06756 1.70968 5.67967 1.94602 5.40582L4.06336 2.95975C4.18831 2.81318 4.36319 2.71118 4.5543 2.67266L7.72337 2.02498C8.07783 1.95201 8.43581 2.10758 8.61321 2.41112L10.1563 5.04481C10.6243 5.84318 10.7789 6.78961 10.5923 7.70984C10.5066 8.13197 10.328 8.55517 10.0469 9.00372L9.0562 10.5875C9.02562 10.6369 8.98343 10.6774 8.93408 10.7064Z",
    fill: "url(#paint0_linear_9308_7853)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9308_7853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.107 9.13838C8.07338 9.15779 8.03589 9.1705 7.99767 9.17438L6.76624 9.29945C6.41673 9.3348 6.11883 9.32003 5.85514 9.25468C5.27816 9.11193 4.80728 8.77293 4.52961 8.29957L3.61503 6.74198C3.50943 6.56224 3.55009 6.32271 3.71549 6.14585L5.19702 4.5659C5.28454 4.4713 5.40317 4.40219 5.5301 4.37144L7.63531 3.85593C7.8708 3.79795 8.10008 3.88008 8.20527 4.05975L9.12052 5.61849C9.39806 6.091 9.46437 6.66604 9.30752 7.23771C9.23552 7.49996 9.10248 7.76632 8.90117 8.05205L8.19162 9.06086C8.1697 9.09232 8.14049 9.11874 8.107 9.13838Z",
    fill: "#6DF0DE",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 1.39057,
    y: -1.044,
    width: 19.3356,
    height: 20.5448
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.01px)",
      clipPath: "url(#bgblur_0_9308_7853_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4.01445
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_9308_7853",
    maskUnits: "userSpaceOnUse",
    x: 3.64125,
    y: 1.21997,
    width: 13.9886,
    height: 15.6614,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 3.64125,
    y: 1.21997,
    width: 13.9886,
    height: 15.6614
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9538 15.3141C9.87856 15.3025 9.80598 15.2737 9.7435 15.2281L7.72976 13.759C7.1584 13.3418 6.72827 12.9061 6.41372 12.4271C5.72517 11.3796 5.44497 10.1278 5.62601 8.90171L6.22036 4.86613C6.28886 4.40036 6.65342 4.02891 7.12657 3.94067L11.3594 3.15785C11.611 3.10935 11.8773 3.14907 12.1075 3.26864L15.9321 5.24185C16.3603 5.46201 16.6018 5.92361 16.5327 6.38869L15.9379 10.4272C15.7578 11.6516 15.1295 12.7686 14.1693 13.5729C13.7288 13.9419 13.191 14.2342 12.5259 14.4674L10.1795 15.2921C10.1066 15.3181 10.0291 15.3251 9.9538 15.3141Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.9538 15.3141C9.87856 15.3025 9.80598 15.2737 9.7435 15.2281L7.72976 13.759C7.1584 13.3418 6.72827 12.9061 6.41372 12.4271C5.72517 11.3796 5.44497 10.1278 5.62601 8.90171L6.22036 4.86613C6.28886 4.40036 6.65342 4.02891 7.12657 3.94067L11.3594 3.15785C11.611 3.10935 11.8773 3.14907 12.1075 3.26864L15.9321 5.24185C16.3603 5.46201 16.6018 5.92361 16.5327 6.38869L15.9379 10.4272C15.7578 11.6516 15.1295 12.7686 14.1693 13.5729C13.7288 13.9419 13.191 14.2342 12.5259 14.4674L10.1795 15.2921C10.1066 15.3181 10.0291 15.3251 9.9538 15.3141Z",
    fill: "#6DF0DE",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92837 15.4794C10.0197 15.4935 10.1051 15.4308 10.1191 15.3395C10.1332 15.2482 10.0705 15.1628 9.97922 15.1488L9.92837 15.4794ZM9.7435 15.2281L9.84209 15.0929L9.84208 15.0929L9.7435 15.2281ZM7.72976 13.759L7.63112 13.8941L7.63118 13.8941L7.72976 13.759ZM6.41372 12.4271L6.55354 12.3353L6.5535 12.3353L6.41372 12.4271ZM5.62601 8.90171L5.79149 8.92614L5.7915 8.92608L5.62601 8.90171ZM6.22036 4.86613L6.38585 4.89051L6.38585 4.89047L6.22036 4.86613ZM7.12657 3.94067L7.09615 3.77619L7.09591 3.77624L7.12657 3.94067ZM11.3594 3.15785L11.3898 3.32234L11.391 3.3221L11.3594 3.15785ZM12.1075 3.26864L12.0304 3.41708L12.0308 3.41729L12.1075 3.26864ZM15.9321 5.24185L15.8554 5.3905L15.8556 5.39061L15.9321 5.24185ZM16.5327 6.38869L16.3673 6.36413L16.3673 6.36432L16.5327 6.38869ZM15.9379 10.4272L15.7725 10.4029L15.7724 10.4029L15.9379 10.4272ZM14.1693 13.5729L14.2767 13.7012L14.2767 13.7012L14.1693 13.5729ZM12.5259 14.4674L12.4706 14.3095L12.4705 14.3096L12.5259 14.4674ZM10.1795 15.2921L10.124 15.1343L10.1233 15.1345L10.1795 15.2921ZM9.97791 15.1486C9.8865 15.1352 9.80159 15.1986 9.78828 15.29C9.77496 15.3814 9.83827 15.4663 9.92968 15.4796L9.97791 15.1486ZM9.9538 15.3141L9.97922 15.1488C9.92912 15.1411 9.8819 15.122 9.84209 15.0929L9.7435 15.2281L9.64491 15.3632C9.73007 15.4253 9.82801 15.464 9.92837 15.4794L9.9538 15.3141ZM9.7435 15.2281L9.84208 15.0929L7.82834 13.6239L7.72976 13.759L7.63118 13.8941L9.64492 15.3632L9.7435 15.2281ZM7.72976 13.759L7.8284 13.6239C7.26965 13.2159 6.85486 12.7941 6.55354 12.3353L6.41372 12.4271L6.27391 12.519C6.60168 13.018 7.04715 13.4677 7.63112 13.8941L7.72976 13.759ZM6.41372 12.4271L6.5535 12.3353C5.88717 11.3215 5.61653 10.111 5.79149 8.92614L5.62601 8.90171L5.46054 8.87727C5.27341 10.1445 5.56317 11.4377 6.27395 12.519L6.41372 12.4271ZM5.62601 8.90171L5.7915 8.92608L6.38585 4.89051L6.22036 4.86613L6.05488 4.84176L5.46053 8.87733L5.62601 8.90171ZM6.22036 4.86613L6.38585 4.89047C6.4436 4.49783 6.7519 4.1807 7.15724 4.10511L7.12657 3.94067L7.09591 3.77624C6.55494 3.87712 6.13413 4.3029 6.05487 4.84179L6.22036 4.86613ZM7.12657 3.94067L7.15699 4.10515L11.3898 3.32233L11.3594 3.15785L11.329 2.99337L7.09615 3.77619L7.12657 3.94067ZM11.3594 3.15785L11.391 3.3221C11.605 3.28086 11.833 3.31456 12.0304 3.41708L12.1075 3.26864L12.1846 3.1202C11.9216 2.98359 11.6171 2.93784 11.3277 2.99361L11.3594 3.15785ZM12.1075 3.26864L12.0308 3.41729L15.8554 5.3905L15.9321 5.24185L16.0088 5.0932L12.1842 3.11999L12.1075 3.26864ZM15.9321 5.24185L15.8556 5.39061C16.2221 5.57902 16.4255 5.97208 16.3673 6.36413L16.5327 6.38869L16.6982 6.41324C16.7781 5.87513 16.4985 5.34499 16.0086 5.09309L15.9321 5.24185ZM16.5327 6.38869L16.3673 6.36432L15.7725 10.4029L15.9379 10.4272L16.1034 10.4516L16.6982 6.41306L16.5327 6.38869ZM15.9379 10.4272L15.7724 10.4029C15.5983 11.5861 14.9911 12.6663 14.0619 13.4447L14.1693 13.5729L14.2767 13.7012C15.2679 12.8709 15.9172 11.7171 16.1034 10.4516L15.9379 10.4272ZM14.1693 13.5729L14.0619 13.4447C13.6399 13.7981 13.121 14.0815 12.4706 14.3095L12.5259 14.4674L12.5813 14.6252C13.2611 14.3869 13.8176 14.0856 14.2767 13.7012L14.1693 13.5729ZM12.5259 14.4674L12.4705 14.3096L10.124 15.1343L10.1795 15.2921L10.2349 15.4499L12.5814 14.6252L12.5259 14.4674ZM10.1795 15.2921L10.1233 15.1345C10.0769 15.1511 10.027 15.1557 9.97791 15.1486L9.9538 15.3141L9.92968 15.4796C10.0312 15.4944 10.1363 15.4851 10.2357 15.4496L10.1795 15.2921Z",
    fill: "url(#paint1_linear_9308_7853)",
    mask: "url(#path-3-outside-1_9308_7853)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 6.30591,
    y: 5.19653,
    width: 9.66602,
    height: 7.89429
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.25px)",
      clipPath: "url(#bgblur_1_9308_7853_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9308_7853)",
    "data-figma-bg-blur-radius": 2.50903
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2051 10.5765C10.0875 10.559 9.97661 10.4987 9.89947 10.3978L8.90712 9.09861C8.75404 8.89698 8.79564 8.6143 9.00057 8.46652C9.2056 8.31814 9.49641 8.36104 9.65019 8.56216L10.3643 9.49652L12.7205 7.79389C12.9262 7.6456 13.217 7.6885 13.3702 7.88953C13.5238 8.09124 13.4822 8.37452 13.2773 8.52171L10.5491 10.4934C10.4462 10.5679 10.3226 10.594 10.2051 10.5765Z",
    fill: "url(#paint2_linear_9308_7853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7299 7.80737C12.9282 7.66437 13.2093 7.70607 13.3569 7.89985C13.5048 8.09413 13.4644 8.36693 13.2673 8.50853L10.5394 10.4801C10.4404 10.5517 10.3212 10.5772 10.2079 10.5605C10.0944 10.5436 9.98673 10.4848 9.91239 10.3876L8.92054 9.08892C8.77316 8.89479 8.81309 8.62253 9.01019 8.48024C9.20786 8.33718 9.48893 8.37879 9.63721 8.57272L10.3512 9.50656L10.361 9.51992L10.3744 9.51012L12.7299 7.80737Z",
    stroke: "url(#paint3_linear_9308_7853)",
    strokeOpacity: 0.5,
    strokeWidth: 0.0334538
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9308_7853",
    x: 0.880581,
    y: 1.16134,
    width: 11.1863,
    height: 10.8331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.33815,
    result: "effect1_foregroundBlur_9308_7853"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7853_clip_path",
    transform: "translate(-1.39057 1.044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9538 15.3141C9.87856 15.3025 9.80598 15.2737 9.7435 15.2281L7.72976 13.759C7.1584 13.3418 6.72827 12.9061 6.41372 12.4271C5.72517 11.3796 5.44497 10.1278 5.62601 8.90171L6.22036 4.86613C6.28886 4.40036 6.65342 4.02891 7.12657 3.94067L11.3594 3.15785C11.611 3.10935 11.8773 3.14907 12.1075 3.26864L15.9321 5.24185C16.3603 5.46201 16.6018 5.92361 16.5327 6.38869L15.9379 10.4272C15.7578 11.6516 15.1295 12.7686 14.1693 13.5729C13.7288 13.9419 13.191 14.2342 12.5259 14.4674L10.1795 15.2921C10.1066 15.3181 10.0291 15.3251 9.9538 15.3141Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9308_7853",
    x: 6.30591,
    y: 5.19653,
    width: 9.66602,
    height: 7.89429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.836345,
    dy: 0.836345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.836345
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.427451 0 0 0 0 0.941176 0 0 0 0 0.870588 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7853"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7853",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7853_clip_path",
    transform: "translate(-6.30591 -5.19653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2051 10.5765C10.0875 10.559 9.97661 10.4987 9.89947 10.3978L8.90712 9.09861C8.75404 8.89698 8.79564 8.6143 9.00057 8.46652C9.2056 8.31814 9.49641 8.36104 9.65019 8.56216L10.3643 9.49652L12.7205 7.79389C12.9262 7.6456 13.217 7.6885 13.3702 7.88953C13.5238 8.09124 13.4822 8.37452 13.2773 8.52171L10.5491 10.4934C10.4462 10.5679 10.3226 10.594 10.2051 10.5765Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7853",
    x1: 7.70576,
    y1: 0.800127,
    x2: 5.30327,
    y2: 9.76236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DF0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DF0DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7853",
    x1: 8.03215,
    y1: 4.02887,
    x2: 14.6689,
    y2: 13.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9308_7853",
    x1: 13.1213,
    y1: 8.31629,
    x2: 8.13396,
    y2: 7.77712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9308_7853",
    x1: 9.38854,
    y1: 8.25417,
    x2: 13.1634,
    y2: 8.86416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiOrganizeControl);
export default __webpack_public_path__ + "static/media/multiOrganizeControl.d3ccced6cae9d7496346b8952598ab62.svg";
export { ForwardRef as ReactComponent };